import { Component, Injector, Input, ViewEncapsulation } from '@angular/core';
import { Module } from 'projects/common/model/ModuleModel';
import { AbstractComponent } from '../abstract.component';

export interface Seal {
  title: string;
  image_url: string;
}

export interface SealsBannerData {
  title: string;
  description: string;
  seals: Seal[];
}

@Component({
  selector: 'seals-banner',
  template: `
        <div *ngIf="module.data" class="seals-banner">
            <div class="seals-banner-text">
                <p *ngIf="module.data.title" class="seals-banner-title -eva-3-bold">{{module.data.title}}</p>
                <p *ngIf="module.data.description" class="seals-banner-description">{{module.data.description}}</p>
            </div>

            <div *ngIf="module.data.seals" class="seals-banner-images" 
                 [ngClass]="{'column-icons': screenType === 'MOBILE'}"> 
                <span *ngFor="let seal of module.data.seals" class="eva-3-tooltip -bottom -center -white -sm seal-image"
                      [ngStyle]="{'position': screenType === 'MOBILE' ? 'static' : 'relative'}">
                    <img [src]="seal.image_url" [alt]="seal.title">
                    <span class="tooltip-container -eva-3-shadow-static ">
                        <i class="tooltip-marker"></i>
                        <span class="tooltip-content">
                            <span class="tooltip-text">{{seal.title}}</span>
                        </span>
                    </span>
                </span>
            </div>
        </div>
    `,
  styleUrls: ['./seals-banner.component.scss'],
  encapsulation: ViewEncapsulation.None
})

export class SealsBannerComponent extends AbstractComponent {
  private static MODULE_ID = 'SealsBannerModule';

  @Input() override module: Module<SealsBannerData>;

  constructor(injector: Injector) {
    super(injector);
  }

  getModuleId(): string {
    return SealsBannerComponent.MODULE_ID;
  }
}
